import type ContextualAddinCommand from './ContextualAddinCommand';

export interface ContextualCalloutState {
    activeContextualAddinCommands: ContextualAddinCommand[];
    contextualAnchor: HTMLElement;
    hostItemIndex: string;
    selectedTerms: string[];
}

export function InitializeContextualCalloutState(): ContextualCalloutState {
    return {
        activeContextualAddinCommands: [],
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (16,9): Type 'null' is not assignable to type 'HTMLElement'.
        // @ts-expect-error
        contextualAnchor: null,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (20,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        hostItemIndex: null,
        selectedTerms: [],
    };
}
